import React, {Fragment, useState} from 'react'
import {ListingSummary} from "../../listings/components";
import {locationToListingSummary, formatPhone} from "../../listings/components/util";


function DocumentHeader({singleLocation, shouldShowLocationInformation}) {
    const hoursPatch = singleLocation.listingManagementSpecs.hours


    return (
        <div className="form-group mt-2 ">
            {shouldShowLocationInformation && <div className="border-top">
                <div className="row">
                    <h5 className="col-3 mt-3">
                        {"Location Information"}
                    </h5>
                </div>
                <div className="row">
                    <div className="col-4 mt-1">
                        {singleLocation.businessName}
                    </div>
                    <div className="col-3 mt-1">
                        {!!singleLocation.listingManagementSpecs && !! singleLocation.listingManagementSpecs.businessEmail ? singleLocation.listingManagementSpecs.businessEmail : "No Email"}
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        {singleLocation.businessAddress ? singleLocation.businessAddress.street : ""}
                    </div>
                    <div className="col-3">
                        {singleLocation.primaryPhoneNumber ? formatPhone(singleLocation.primaryPhoneNumber) : "No Phone"}
                    </div>
                </div>
                <div className={"row"}>
                    <div className="col-4">
                        {singleLocation.businessAddress ? singleLocation.businessAddress.city + ", " + singleLocation.businessAddress.state + " " + singleLocation.businessAddress.postalCode : ""}
                    </div>
                </div>
                <div className="mt-2">
                    {hoursPatch.map((day, index) => {
                        return <div key={"div-1-" + index} className="row">
                            <div key={"div-2-" + index} className="col-4">
                                <b key={"b" + index}>{day.name}:{" "}</b>
                                {!day.hasNone && !day.open24Hours && !day.isClosed && day.hourBlocks.map((hourBlock, hourIndex) => {
                                    return <Fragment key={"fragement-" + index}><span
                                        key={"span" + index + "" + hourIndex}>
              Open from {moment(hourBlock.openTime, 'HH:mm').format('hh:mm a')} to {moment(hourBlock.closeTime, 'HH:mm').format('hh:mm a')}
            </span><br/></Fragment>
                                })}
                                {day.open24Hours && <span key={"span-1-" + index}>Open 24 Hours</span>}
                                {day.isClosed && <span key={"span-2-" + index}>Closed</span>}
                                {day.hasNone && <span key={"span-3-" + index}>None</span>}
                            </div>
                        </div>
                    })}
                </div>
            </div>}
        </div>
    )

}

export default DocumentHeader;